import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "device-lock",
  "use": "device-lock-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"device-lock\"><path d=\"M8.5 15v-2h3v2h-3z\" /><path d=\"M5 6.8A2.8 2.8 0 0 1 7.8 4h4.4A2.8 2.8 0 0 1 15 6.8V9h1.8a1.2 1.2 0 0 1 1.2 1.2v7.6a1.2 1.2 0 0 1-1.2 1.2H3.2A1.2 1.2 0 0 1 2 17.8v-7.6A1.2 1.2 0 0 1 3.2 9H5V6.8zM7 9h6V6.8a.8.8 0 0 0-.8-.8H7.8a.8.8 0 0 0-.8.8V9zm9 2H4v6h12v-6z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol